/* Galerie & Kunsthaus Nottbohm — Werkseite

   Zwei Spalten im Goldenen Schnitt (0,382 zu 0,618), jede mit eigenem
   Fluss — dadurch rückt die Einrahmung unmittelbar unter das Werk:

     links (schmal)   Bestell- und Anfragekachel, Lieferung
     rechts (breit)   Werk-Abbildungskachel, darunter Einrahmung, Echtheit
                       — Echtheit sitzt rechts, damit sie dieselbe Breite
                       wie die Einrahmungskachel bekommt und links kein
                       Leerraum unter der Lieferkachel entsteht

   Werk-Abbildungskachel: immer genau so breit wie die Einrahmungskachel
   darunter (beide sitzen in derselben Spalte). Die Höhe richtet sich
   allein nach dem Seitenverhältnis des Werkbilds — nicht mehr nach der
   Fensterhöhe:
     Hochformat (schmaler als hoch)   Kachel ist ein Quadrat, Bild darin
                                       zentriert und vollständig sichtbar
     Querformat (breiter als hoch)    Kachel-Höhe ergibt sich aus dem
                                       Seitenverhältnis, Breite wie die
                                       Einrahmungskachel, Werk vollständig
                                       abgebildet
   Mobil (unter 900 px) gilt stattdessen: so groß wie möglich, aber
   vollständig sichtbar — volle Breite; wäre das Werk dann höher als der
   sichtbare Bereich unter der Kopfzeile, wird es auf diese Höhe begrenzt
   und zentriert vollständig gezeigt. Die Reihenfolge mobil (Bild,
   Produktinformation, dann Einrahmung, Lieferung, Echtheit) regelt
   nottbohm-werkseite.css.
   Beide Fälle werden aus der tatsächlichen Breite der Kachel berechnet
   (nicht aus window.innerHeight) — dadurch unabhängig von Fenstergröße
   und Bildlaufposition, und bei jeder Breitenänderung (Umbruch bei
   900 px, Fenster resizen) neu berechnet.

   Bildbereich: angesprochen über die festen Theme-Klassen, nicht über
   eine Bildsuche auf der Seite:
     .product-media             ganzer Galerieblock (Hauptbild + Thumbnails)
     .product-media__container  nur der Hauptbild-Schieber, ohne Thumbnails
   Größenberechnung und Stil greifen gezielt nur auf den Hauptbild-
   Schieber zu, damit die Thumbnail-Leiste unangetastet bleibt.
*/
(function () {
	"use strict";

	var W = window.nottbohmWerk || null;
	var KONTAKT = "/pages/contact";

	var LINKS = ["Lieferung"];

	/* Diese Kacheln bekommen keinen eigenen "Jetzt anfragen"-Button mehr —
	   die Anfrage läuft bereits über die Bestell- und Anfragekachel oben. */
	var OHNE_ANFRAGE_BUTTON = ["Einrahmung"];

	function saeubern(t) {
		return (t || "").replace(/\s+/g, " ").trim().toLowerCase();
	}

	function medienbereich() {
		var fertig = document.querySelector(".nb-werk-medien");
		if (fertig) return fertig;
		return document.querySelector(".product-media");
	}

	function hauptSlider(medien) {
		if (!medien) return null;
		return medien.querySelector(".product-media__container") || medien;
	}

	/* Sichtbare Bildschirmhöhe mobil. Gemessen über 100svh (kleinster
	   Viewport, also mit eingeblendeter Adressleiste) — bleibt beim
	   Scrollen stabil, anders als window.innerHeight. */
	function sichthoehe() {
		var probe = document.getElementById("nb-sichthoehe");
		if (!probe) {
			probe = document.createElement("div");
			probe.id = "nb-sichthoehe";
			probe.setAttribute("aria-hidden", "true");
			probe.style.cssText = "position:fixed;top:0;left:0;width:0;height:100vh;height:100svh;visibility:hidden;pointer-events:none";
			document.body.appendChild(probe);
		}
		return probe.getBoundingClientRect().height || window.innerHeight;
	}

	/* ---------- Werk-Abbildungskachel ---------- */

	function werkAbbildung() {
		if (!W) return;
		var medien = medienbereich();
		if (!medien) return;
		var haupt = hauptSlider(medien);
		if (!haupt) return;

		var bilder = haupt.querySelectorAll("img");
		if (!bilder.length) return;
		var erstes = bilder[0];

		if (!erstes.complete || !erstes.naturalWidth || !erstes.naturalHeight) {
			erstes.addEventListener("load", werkAbbildung, { once: true });
			return;
		}

		/* Breite an der Kachel selbst messen, nicht am Hauptbild-Schieber:
		   .product-media__container trägt im Theme zusätzlich die Klasse
		   js-product-sticky-container und bekommt dort mitunter eine eigene
		   Breite gesetzt. Die Kachel (.nb-werk-medien) gehört uns vollständig
		   und ist immer so breit wie die Einrahmungskachel darunter. */
		var breite = Math.round(medien.getBoundingClientRect().width) || medien.clientWidth;
		if (!breite) return;

		var verhaeltnis = erstes.naturalHeight / erstes.naturalWidth;
		var hochformat, hoehe;

		if (window.matchMedia("(max-width: 899px)").matches) {
			/* Mobil: so groß wie möglich, aber vollständig sichtbar.
			   Das Werk nimmt die volle Breite ein. Wäre es dann höher als
			   der sichtbare Bereich unterhalb der Kopfzeile, wird die Höhe
			   darauf begrenzt und das Werk zentriert vollständig gezeigt. */
			var sicht = sichthoehe();
			var oben = medien.getBoundingClientRect().top + (window.pageYOffset || 0);
			var maxHoehe = Math.max(Math.round(sicht - oben - 12), Math.round(sicht * 0.55));
			var natuerlich = Math.round(breite * verhaeltnis);
			hochformat = natuerlich > maxHoehe;
			hoehe = Math.min(natuerlich, maxHoehe);
		} else {
			hochformat = erstes.naturalWidth < erstes.naturalHeight;
			hoehe = hochformat ? breite : Math.round(breite * verhaeltnis);
		}

		medien.classList.toggle("nb-hoch", hochformat);
		medien.classList.toggle("nb-breit", !hochformat);
		medien.setAttribute("data-nb-hoehe", hoehe);
		medien.setAttribute("data-nb-breite", breite);

		medien.style.setProperty("width", "100%", "important");
		medien.style.setProperty("max-width", "100%", "important");

		/* Hauptbild-Schieber unabhängig von seiner eigenen (Sticky-)Breite
		   auf die volle Kachelbreite zwingen. */
		haupt.style.setProperty("width", "100%", "important");
		haupt.style.setProperty("max-width", "100%", "important");
		haupt.style.setProperty("box-sizing", "border-box", "important");
		haupt.style.setProperty("height", hoehe + "px", "important");
		haupt.style.setProperty("overflow", "hidden", "important");
		haupt.style.setProperty("display", "flex", "important");
		haupt.style.setProperty("align-items", "center", "important");
		haupt.style.setProperty("justify-content", "center", "important");

		Array.prototype.forEach.call(bilder, function (b) {
			b.style.setProperty("display", "block", "important");
			b.style.setProperty("object-fit", "contain", "important");
			b.style.setProperty("margin-left", "auto", "important");
			b.style.setProperty("margin-right", "auto", "important");
			b.style.setProperty("max-width", "100%", "important");
			b.style.setProperty("max-height", hoehe + "px", "important");
			if (hochformat) {
				b.style.setProperty("width", "auto", "important");
				b.style.setProperty("height", "auto", "important");
			} else {
				b.style.setProperty("width", "100%", "important");
				b.style.setProperty("height", hoehe + "px", "important");
			}
		});

		Array.prototype.forEach.call(haupt.querySelectorAll("model-viewer"), function (m) {
			m.style.setProperty("width", "100%", "important");
			m.style.setProperty("height", hoehe + "px", "important");
			m.style.setProperty("max-height", hoehe + "px", "important");
		});

		var behaelter = haupt.querySelectorAll('[class*="image"], [class*="media"], picture, figure');
		Array.prototype.forEach.call(behaelter, function (el) {
			el.style.setProperty("aspect-ratio", "auto", "important");
			el.style.setProperty("min-height", "0", "important");
			el.style.setProperty("padding-bottom", "0", "important");
			el.style.setProperty("width", "100%", "important");
			el.style.setProperty("max-width", "100%", "important");
			el.style.setProperty("height", hoehe + "px", "important");
		});
	}

	/* ---------- Umbau ---------- */

	function anfrageAdresse(anliegen) {
		var u = new URL(KONTAKT, window.location.origin);
		u.searchParams.set("anliegen", anliegen);
		u.searchParams.set("als", "button");
		u.searchParams.set("werk", W.titel);
		if (W.kuenstler) u.searchParams.set("kuenstler", W.kuenstler);
		if (W.sku) u.searchParams.set("sku", W.sku);
		return u.pathname + u.search;
	}

	function kachelBauen(daten) {
		var kachel = document.createElement("div");
		kachel.className = "nb-kachel nb-service";
		kachel.setAttribute("data-nb-kachel", daten.titel);

		var h = document.createElement("h2");
		h.className = "nb-kachel-titel";
		h.textContent = daten.titel;
		kachel.appendChild(h);

		var inhalt = document.createElement("div");
		inhalt.className = "nb-kachel-inhalt";
		(daten.text || "").split(/\n\s*\n/).forEach(function (absatz) {
			var t = absatz.trim();
			if (!t) return;
			var p = document.createElement("p");
			p.textContent = t;
			inhalt.appendChild(p);
		});
		kachel.appendChild(inhalt);

		if (daten.anliegen && OHNE_ANFRAGE_BUTTON.indexOf(daten.titel) === -1) {
			var a = document.createElement("a");
			a.setAttribute("href", anfrageAdresse(daten.anliegen));
			a.setAttribute("data-nb", "1");
			a.textContent = "Jetzt anfragen";
			kachel.appendChild(a);
		}
		return kachel;
	}

	function werkseite() {
		if (!W) return;
		if (document.querySelector(".nb-werk")) return;

		var formular = null;
		var f = document.querySelectorAll('form[action*="/cart/add"]');
		for (var i = 0; i < f.length; i++) {
			if (f[i].offsetParent !== null) { formular = f[i]; break; }
		}
		if (!formular) return;

		var medienWurzel = document.querySelector(".product-media");
		if (!medienWurzel) return;

		var raster = medienWurzel.parentElement;
		while (raster && !raster.contains(formular)) raster = raster.parentElement;
		if (!raster || raster === document.body) return;

		var medien = null, info = null;
		Array.prototype.forEach.call(raster.children, function (kind) {
			if (kind.contains(medienWurzel)) medien = kind;
			if (kind.contains(formular)) info = kind;
		});
		if (!medien || !info || medien === info) return;

		Array.prototype.slice.call(info.children).forEach(function (el) {
			var t = saeubern(el.textContent);
			if (t.indexOf("startseite") === 0 && el.querySelector('a[href="/"]')) el.remove();
		});

		Array.prototype.forEach.call(info.querySelectorAll("a, button, span"), function (el) {
			var t = saeubern(el.textContent);
			if (t === "mehr anzeigen" || t === "weniger anzeigen") el.remove();
		});

		var bestell = document.createElement("div");
		bestell.className = "nb-kachel nb-bestell";
		Array.prototype.slice.call(info.children).forEach(function (el) {
			bestell.appendChild(el);
		});
		Array.prototype.forEach.call(bestell.children, function (el) {
			if (saeubern(el.textContent).indexOf("abholung") > -1) el.classList.add("nb-abholung");
		});

		var links = document.createElement("div");
		links.className = "nb-spalte-links";
		links.appendChild(bestell);

		var rechts = document.createElement("div");
		rechts.className = "nb-spalte-rechts";
		medien.classList.add("nb-werk-medien");
		rechts.appendChild(medien);

		(W.kacheln || []).forEach(function (daten) {
			if (!daten.text || !daten.text.trim()) return;
			var kachel = kachelBauen(daten);
			if (LINKS.indexOf(daten.titel) > -1) links.appendChild(kachel);
			else rechts.appendChild(kachel);
		});

		var werk = document.createElement("div");
		werk.className = "nb-werk";
		werk.appendChild(links);
		werk.appendChild(rechts);

		if (raster.parentNode) raster.parentNode.classList.add("nb-werk-huelle");
		raster.parentNode.insertBefore(werk, raster);
		if (info.parentNode) info.parentNode.removeChild(info);
		if (raster.parentNode) raster.parentNode.removeChild(raster);
	}

	function farbflaechen() {
		var abschnitte = document.querySelectorAll('[id^="shopify-section"]:not([data-nb-flaeche])');
		Array.prototype.forEach.call(abschnitte, function (abschnitt) {
			abschnitt.setAttribute("data-nb-flaeche", "1");
			Array.prototype.forEach.call(abschnitt.querySelectorAll("div, section"), function (el) {
				if (window.getComputedStyle(el).backgroundColor !== "rgb(29, 51, 111)") return;
				if (el.getBoundingClientRect().width < 600) return;
				if (el.closest(".nb-blauband")) return;
				el.classList.add("nb-blauband");
			});
		});
	}

	function start() {
		try { werkseite(); } catch (e) { /* Umbau darf die Kachel nicht verhindern */ }
		werkAbbildung();
		farbflaechen();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start);
	} else {
		start();
	}

	window.addEventListener("load", function () {
		start();
		werkAbbildung();
	});

	var warte;
	window.addEventListener("resize", function () {
		window.clearTimeout(warte);
		warte = window.setTimeout(function () { werkAbbildung(); }, 150);
	});

	if (window.MutationObserver) {
		var wartet = false;
		new MutationObserver(function () {
			if (wartet) return;
			wartet = true;
			window.setTimeout(function () { wartet = false; start(); }, 300);
		}).observe(document.body, { childList: true, subtree: true });
	}
})();